export const WarningSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M9.5 16.9199C5.35775 16.9199 2 13.5622 2 9.41992C2 5.27767 5.35775 1.91992 9.5 1.91992C13.6423 1.91992 17 5.27842 17 9.41992C17 13.5614 13.6423 16.9199 9.5 16.9199ZM9.5 5.66992C9.30109 5.66992 9.11032 5.74894 8.96967 5.88959C8.82902 6.03024 8.75 6.22101 8.75 6.41992V10.1699C8.75 10.3688 8.82902 10.5596 8.96967 10.7003C9.11032 10.8409 9.30109 10.9199 9.5 10.9199C9.69891 10.9199 9.88968 10.8409 10.0303 10.7003C10.171 10.5596 10.25 10.3688 10.25 10.1699V6.41992C10.25 6.22101 10.171 6.03024 10.0303 5.88959C9.88968 5.74894 9.69891 5.66992 9.5 5.66992ZM9.5 13.1699C9.69891 13.1699 9.88968 13.0909 10.0303 12.9503C10.171 12.8096 10.25 12.6188 10.25 12.4199C10.25 12.221 10.171 12.0302 10.0303 11.8896C9.88968 11.7489 9.69891 11.6699 9.5 11.6699C9.30109 11.6699 9.11032 11.7489 8.96967 11.8896C8.82902 12.0302 8.75 12.221 8.75 12.4199C8.75 12.6188 8.82902 12.8096 8.96967 12.9503C9.11032 13.0909 9.30109 13.1699 9.5 13.1699Z"
        fill="#F8991D"
      />
    </svg>
  );
};
